module.exports = __webpack_public_path__ + "static/media/fj.4cea5e87.webp";